import React, { useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faUnlockAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Image,
  Container,
  InputGroup,
} from "react-bootstrap";

import BgImage from "../assets/img/vite/vitebackground.png";
import Logo from "../assets/img/vite/ViteLogoOnly.png";
import * as yup from "yup";
import { useFormik } from "formik";
import { useAuth } from "../hooks/auth.hook";
import LoadingComponent from "../components/LoadingComponent";
import { errorToast } from "../utils/toast";

function RestartPassword() {
  let auth = useAuth();
  let history = useHistory();
  const search = useLocation().search;
  const code = new URLSearchParams(search).get("code");
  const id = new URLSearchParams(search).get("id");

  const restartSchema = yup.object({
    password: yup
      .string()
      .max(128)
      .min(6, "Se requiere una contraseña de al menos 6 caracteres")
      .required("La contraseña no puede estar vacía"),
    checkPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Las contraseñas deben ser iguales")
      .required("Debes confirmar tu contraseña"),
  });

  const handleRestartPasswordSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    setIsLoading(true);
    auth
      .restartPassword(values.password, code, id)
      .then((result) => {
        if (result !== null && result !== undefined) {
          history.push({
            pathname: "/login",
            state: {
              // location state
              success_restart: true,
              valid_email: null,
            },
          });
        }
      })
      .catch((error) => {
        //remove loader
        setIsLoading(false);
        console.log(error);
        errorToast(error);
      })
      .finally(() => {
        setSubmitting(false);
        setIsLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: { password: "", checkPassword: "" },
    validationSchema: restartSchema,
    onSubmit: handleRestartPasswordSubmit,
  });
  const [isLoading, setIsLoading] = useState(false);

  return (
    <main style={{ height: "100%", width: "100%" }}>
      <section className="d-flex align-items-center">
        <Container
          fluid
          style={{
            backgroundImage: `url(${BgImage})`,
            backgroundRepeat: `repeat`,
            height: `100vh`,
            width: `100vw`,
          }}
        >
          <Container className=" my-5 mt-lg-6 mb-lg-5">
            <Row className="justify-content-center form-bg-image">
              <Col
                xs={12}
                className="d-flex align-items-center justify-content-center"
                style={{ position: "relative" }}
              >
                {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center fmxw-500"></LoadingComponent>
                  </>
                )}
                <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h3 className="mb-0">Restablecer tu contraseña</h3>
                  </div>
                  <Form
                    className="mt-4"
                    onSubmit={formik.handleSubmit}
                    method="post"
                  >
                    <Form.Group className="mb-4">
                      <Form.Label>Tu contraseña</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          id="password"
                          type="password"
                          maxLength="128"
                          placeholder="Contraseña"
                          className={` ${
                            formik.touched.password && formik.errors.password
                              ? "invalid"
                              : ""
                          } ${
                            formik.touched.password && !formik.errors.password
                              ? "valid"
                              : ""
                          }`}
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </InputGroup>
                      {formik.touched.password && formik.errors.password && (
                        <div style={{ position: "absolute", display: "flex" }}>
                          <small
                            className="invalid-feedback"
                            style={{ display: "inline-block" }}
                          >
                            {" "}
                            <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                            {formik.errors.password}
                          </small>
                        </div>
                      )}
                    </Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label>Confirmar contraseña</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          id="checkPassword"
                          type="password"
                          maxLength="128"
                          placeholder="Confirmar contraseña"
                          className={` ${
                            formik.touched.checkPassword &&
                            formik.errors.checkPassword
                              ? "invalid"
                              : ""
                          } ${
                            formik.touched.checkPassword &&
                            !formik.errors.checkPassword
                              ? "valid"
                              : ""
                          }`}
                          value={formik.values.checkPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </InputGroup>
                      {formik.touched.checkPassword &&
                        formik.errors.checkPassword && (
                          <div
                            style={{ position: "absolute", display: "flex" }}
                          >
                            <small
                              className="invalid-feedback"
                              style={{ display: "inline-block" }}
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={faExclamationCircle}
                              />{" "}
                              {formik.errors.checkPassword}
                            </small>
                          </div>
                        )}
                    </Form.Group>
                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      disabled={
                        formik.isSubmitting ||
                        Object.keys(formik.errors).length > 0
                      }
                    >
                      Restablecer contraseña
                    </Button>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </section>
    </main>
  );
}

export default RestartPassword;
